export const indexTopics = [
  {
    no: "01",
    title: "黑料网站靠谱吗",
    question: "值不值得长期看",
    desc: "从信息源、更新节奏、纠错机制三个角度，判断一个爆料站是认真在做还是纯蹭热度。",
    tone: "primary",
  },
  {
    no: "02",
    title: "黑料网站好用吗",
    question: "翻旧料顺不顺手",
    desc: "手机端加载、站内搜索命中率、历史归档完整度，这三点决定你找料会不会翻到崩溃。",
    tone: "accent",
  },
  {
    no: "03",
    title: "黑料网站打不开",
    question: "白屏不等于凉了",
    desc: "换网络、清缓存、换浏览器都试过还是进不去，多半是线路在切换，别急着下结论。",
    tone: "secondary",
  },
  {
    no: "04",
    title: "黑料网站审核慢",
    question: "排队还是被吞",
    desc: "投稿进入审核队列后，快慢取决于时段和内容敏感度，并不等于你的内容被拒了。",
    tone: "primary",
  },
  {
    no: "05",
    title: "黑料网站验证多",
    question: "每一步为什么来",
    desc: "人机验证、短信码、邮箱二次确认，逐条说清它们出现的条件，以及怎么少被打断。",
    tone: "accent",
  },
  {
    no: "06",
    title: "黑料网站广告烦",
    question: "哪些是站方的",
    desc: "弹窗、贴片、跳转，先分清哪些来自页面本身、哪些来自你的浏览环境，再谈减少。",
    tone: "secondary",
  },
];

export const timelineItems = [
  {
    date: "09.12",
    time: "凌晨",
    tag: "线路",
    title: "夜间线路维护已完成",
    desc: "凌晨 1:00 至 3:00 部分线路短暂白屏，属例行调整，天亮后各入口恢复正常访问。",
  },
  {
    date: "09.08",
    time: "上午",
    tag: "审核",
    title: "审核队列明显提速",
    desc: "资料类投稿的平均过审时间从约 6 小时降到 3 小时左右，晚间高峰依旧会慢一些。",
  },
  {
    date: "09.02",
    time: "下午",
    tag: "验证",
    title: "连续登录设备验证简化",
    desc: "同一设备连续登录不再每次都弹短信码，只有更换设备或异地登录才会触发二次确认。",
  },
  {
    date: "08.27",
    time: "傍晚",
    tag: "好用",
    title: "移动端阅读改版上线",
    desc: "手机端点开料条不再强制跳外部浏览器，站内即可读完整篇，返回列表也不再丢位置。",
  },
  {
    date: "08.19",
    time: "中午",
    tag: "广告",
    title: "首屏弹窗收敛",
    desc: "关闭首屏弹窗后不再连环弹出，贴片广告减少到每页一条，跳转类广告已明显变少。",
  },
  {
    date: "08.11",
    time: "上午",
    tag: "靠谱",
    title: "历史归档补齐",
    desc: "2021 至 2022 年的旧料补进索引，站内搜索命中率上升，翻旧料终于不用靠外部链接。",
  },
];

export const galleryCards = [
  {
    eyebrow: "图鉴 · 手机端",
    title: "通勤路上翻料，顺不顺看这三点",
    points: ["列表首屏加载约 1.2 秒", "搜索支持标题与标签双命中", "返回列表保留原浏览位置"],
  },
  {
    eyebrow: "图鉴 · 桌面端",
    title: "桌面端归档与搜索，适合查旧事",
    points: ["按年份与标签双维度筛选", "长文支持目录快速跳转", "复制引用自动带上来源时间"],
  },
];

export const faqItems = [
  {
    q: "黑料网站靠谱吗？里面的内容能直接当成事实吗？",
    a: "把它当成线索集更稳妥。靠谱的用法是看它是否标注时间、是否给出可核对的信息源、出错后是否更正。本页汇总的反馈也提醒：任何单一爆料都不该成为你判断一个人的唯一依据。",
  },
  {
    q: "黑料网站打不开，是不是被封了？",
    a: "不一定。多数打不开来自线路调整、本地缓存过期或当前网络环境限制。可以按顺序试：切换网络、清理缓存、更换浏览器；若多个入口同时白屏且持续超过一天，再考虑是站点侧的问题。",
  },
  {
    q: "投稿后审核慢，是不是等于没通过？",
    a: "两者不是一回事。审核慢通常只是排队，晚间与敏感内容会更久。建议不要重复投同一份内容，耐心等通知即可，重复投稿反而会增加队列负担。",
  },
  {
    q: "为什么黑料网站验证这么多？",
    a: "验证主要针对异常行为：更换设备、异地登录、短时间高频操作。固定设备稳定使用后，短信码与邮箱二次确认会明显减少；如果每次都要验证，先检查是否开了隐私模式或频繁清 Cookie。",
  },
  {
    q: "广告烦人，能少一点吗？",
    a: "先分清来源。站内贴片与弹窗属于页面本身，关闭后一般不会无限重弹；而那些整屏跳转、带下载按钮的，往往来自你所在的浏览环境或第三方插件，换一个干净的浏览器就能少一大半。",
  },
];

export const feedbackQuotes = [
  {
    text: "打不开那会儿我以为凉了，结果第二天自己就好了，后来才知道是线路在切。",
    meta: "杭州 · 连续三年老读者",
  },
  {
    text: "审核慢是真的慢，但过审会有通知，别同一份内容反复投，越投越乱。",
    meta: "成都 · 投稿人",
  },
  {
    text: "换手机那阵验证是真的多，稳定用了几天之后就基本不弹了，能理解。",
    meta: "广州 · 手机端用户",
  },
];

export const tickerLines = [
  "夜间线路维护已完成，各入口恢复正常",
  "审核队列提速，资料类投稿平均约 3 小时过审",
  "移动端阅读改版上线，站内即可读完",
  "历史归档补齐至 2021 年，搜索命中率上升",
];

export const stats = [
  { value: "128", label: "条真实体验反馈" },
  { value: "06", label: "个高频困扰问题" },
  { value: "3h", label: "资料类平均过审" },
];

export const mastheadFacts = [
  { label: "本期", value: "读者观察报告 · 第 09 期" },
  { label: "更新", value: "2026 年 9 月 12 日" },
  { label: "样本", value: "128 条读者反馈" },
];